export const ADDRESS = 'ADDRESS';
export const BULK = 'BULK';
export const BUSINESS = 'BUSINESS';
export const ZIPCODE = 'ZIPCODE';
export const address = 'address';
export const zipcode = 'zipcode';
